import React, { createContext, useContext, useState, useEffect } from 'react';

const ThemeContext = createContext();

export const useTheme = () => useContext(ThemeContext);

const colorThemes = {
  'color-1': '#f85408',
  'color-2': '#cf213b',
  'color-3': '#70c7a6',
  'color-4': '#1854b4',
  'color-5': '#CF3088',
};

export const ThemeProvider = ({ children }) => {
  const [darkMode, setDarkMode] = useState(() => {
    return localStorage.getItem('dark-mode') === 'enabled';
  });
  
  const [skinColor, setSkinColor] = useState(() => {
    return localStorage.getItem('selected-color') || 'color-1';
  });

  useEffect(() => {
    if (darkMode) {
      document.documentElement.classList.add('dark');
      document.body.classList.add('dark');
    } else {
      document.documentElement.classList.remove('dark');
      document.body.classList.remove('dark');
    }
    localStorage.setItem('dark-mode', darkMode ? 'enabled' : 'disabled');
  }, [darkMode]);

  useEffect(() => {
    const color = colorThemes[skinColor] || colorThemes['color-1'];
    document.documentElement.style.setProperty('--skin-color', color);
    localStorage.setItem('selected-color', skinColor);
  }, [skinColor]);

  const toggleDarkMode = () => setDarkMode(!darkMode);
  const setColorTheme = (color) => setSkinColor(color);

  return (
    <ThemeContext.Provider value={{ darkMode, toggleDarkMode, skinColor, setColorTheme, colorThemes }}>
      {children}
    </ThemeContext.Provider>
  );
};
